import script from "./Component-05.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-05.vue?vue&type=script&setup=true&lang=js"

import "./Component-05.vue?vue&type=style&index=0&id=f575449e&lang=scss"

const __exports__ = script;

export default __exports__